
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import Read from "./read.vue";
import { PostDeviceChart } from "@/request/workstation";
import { getXinzangList } from "@/request/doctor";
import TimeRange from "../time-range/time-range.vue";
@Component({
  components: {
    Read,
    TimeRange,
  },
})
export default class Name extends mixins(listMixin) {
  @Prop()
  private part: any;
  @Watch("part", { immediate: true })
  private partChange() {
    if (this.part === "心脏无忧筛查") {
      this.readId = "";
      this.getList();
    }
  }
  private ifShowRead: any = false;
  private data: any = [];
  private readId: any = "";
  private detail: any = {};
  private get patient() {
    return this.$store.state.patient;
  }
  private goRead(item: any) {
    this.detail = item;
    this.ifShowRead = true;
  }
  private timeChange(d: any) {
    this.filters = JSON.parse(JSON.stringify(d));
    this.search();
  }
  getList() {
    this.data = [];
    const params: any = {
      begin_date: this.filters.startTime,
      end_date: this.filters.endTime,
      patient_id: this.patient.patient_id,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    getXinzangList(this, params)
      .then((data: any) => {
        loading.close();
        this.data = data.datas;
        this.filters.total_count = data.total_count;
        this.filters.total_page = data.total_page;
        if (this.data.length === 0) {
          this.ifShowEmpty = true;
        } else {
          this.ifShowEmpty = false;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
}
